itsoftApp.createModule("social", function () {
    const yaShareTrigger = document.querySelector(".ya-share-trigger");

    if (yaShareTrigger) {
        const yaShare = document.querySelector(".ya-share2");

        const scriptShr = document.createElement('script');

        scriptShr.setAttribute('src','https://yastatic.net/share2/share.js',);

        scriptShr.setAttribute('async', '');

        window.addEventListener('load', () => {
            setTimeout(() => {
                document.body.appendChild(scriptShr);
            }, 3000);
        })
    }

    const isJsonString = function (str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    const changeLikeCount = function (response) {
        let parseResponse = null;

        if (isJsonString(response)) {
            parseResponse = JSON.parse(response);
        }
    }

    const sendRequest = function (url) {
        const xhr = new XMLHttpRequest();

        xhr.addEventListener("load", function () {
            if (xhr.status === 200) {
                changeLikeCount(xhr.response);
            } else {
                console.log(xhr.response, ' xhr.response ERROR')
            }
        });

        xhr.addEventListener("error", function () {
            onError("Произошла ошибка соединения");
        });

        xhr.addEventListener("timeout", function () {
            onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
        });

        xhr.timeout = 10000;

        xhr.open("GET", url);
        // xhr.open("POST", url);
        xhr.send();
    }

    const likeButton = document.querySelector(".js-like");
    const action = likeButton && likeButton.getAttribute("data-url");

    if (likeButton) {
        likeButton.addEventListener("click", function (evt) {
            evt.preventDefault();
            let url = "?";

            likeButton.classList.toggle("is-active");

            url += "like" + "=" + likeButton.classList.contains("is-active");
            url += "&" + "id" + "=" + likeButton.getAttribute("data-id") || null;
            const query = action + url;

            sendRequest(query);
        })
    }
});